import { computed } from 'mobx'
import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import type { LegendPartDependencies } from './legend-part-dependencies'

/**
 * Base for the view models that edit a part of the legend, from the builders
 * down to a single symbol picker. A part's reactions and children live in its
 * lifecycle, and its parent manages it, so it only reacts while it is in the
 * legend editor's tree and the editor is active.
 */
export abstract class LegendPartViewModelBase implements ActivationLifecycle {
  protected readonly lifecycle = new LifecycleTracker()
  protected readonly dependencies: LegendPartDependencies

  constructor(dependencies: LegendPartDependencies) {
    this.dependencies = dependencies
  }

  /**
   * Whether the legend can't be edited.
   */
  @computed
  get isEditingDisabled() {
    return this.dependencies.isEditingDisabled()
  }

  /** @inheritDoc */
  activate() {
    this.lifecycle.activate()
  }

  /** @inheritDoc */
  deactivate() {
    this.lifecycle.deactivate()
  }
}
